export const convertStorage = (storage) => storage>=1000 ? (storage/1000): storage

export const getUnits = (storage) => storage>=1000 ? "TB": "GB"